/* =========================================================
   VENTURE Archives — Notify Me When Available.
   Captures email per product, sends to Worker which subscribes
   the profile to the (Venture) List + fires a "Notify Me Request"
   event tagged with product handle.
   ========================================================= */
(function () {
  'use strict';

  var WORKER = 'https://venture-raffle.paulventura.workers.dev/notify-me';
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  document.addEventListener('DOMContentLoaded', init);

  function init() {
    var blocks = document.querySelectorAll('[data-notify-me]');
    for (var i = 0; i < blocks.length; i++) wireBlock(blocks[i]);
  }

  function wireBlock(root) {
    var trigger = root.querySelector('[data-notify-trigger]');
    var input = root.querySelector('[data-notify-email]');
    var submit = root.querySelector('[data-notify-submit]');
    var errorEl = root.querySelector('[data-notify-error]');

    if (trigger) {
      trigger.addEventListener('click', function () {
        root.setAttribute('data-open', 'true');
        setTimeout(function () { try { input.focus(); } catch (e) {} }, 80);
      });
    }

    function doSubmit() {
      if (!input || !submit) return;
      errorEl.textContent = '';
      var email = (input.value || '').trim().toLowerCase();
      if (!EMAIL_RE.test(email)) {
        errorEl.textContent = 'enter a valid email.';
        input.focus();
        return;
      }

      setBusy(submit, true);

      var payload = {
        email: email,
        product_handle: root.getAttribute('data-product-handle') || '',
        product_title: root.getAttribute('data-product-title') || '',
        variant_id: root.getAttribute('data-variant-id') || ''
      };

      fetch(WORKER, {
        method: 'POST',
        mode: 'cors',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (r) {
          return r.json().then(
            function (b) { return { status: r.status, body: b }; },
            function ()  { return { status: r.status, body: { error: 'invalid response.' } }; }
          );
        })
        .then(function (res) {
          setBusy(submit, false);
          if (res.status === 200 && res.body && res.body.success) {
            root.setAttribute('data-state', 'success');
            return;
          }
          errorEl.textContent = (res.body && res.body.error) || 'something went wrong. try again.';
        })
        .catch(function () {
          setBusy(submit, false);
          errorEl.textContent = 'network error. try again.';
        });
    }

    if (submit) submit.addEventListener('click', doSubmit);
    if (input) input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); doSubmit(); }
    });
  }

  function setBusy(btn, busy) {
    if (!btn) return;
    btn.disabled = !!busy;
    btn.setAttribute('aria-busy', busy ? 'true' : 'false');
  }
})();
